/**
 * Central definition of variant tags.
 * Add new variants here — they'll appear automatically on Cart, Checkout, and Order pages.
 *
 * Each entry: [label, value]
 * Only entries with a truthy value are shown.
 */

// For cart items (Shopping Cart, Checkout Order Summary)
export function getVariantTags(item) {
  return [
    item?.Variation?.variation_name && ["Metal", item.Variation.variation_name],
    item?.Variation?.color && ["Colour", item.Variation.color],
    item?.SizeName && ["Size", item.SizeName],
    item?.quality && ["Quality", item.quality],
    item?.centreStoneOption?.carat && ["Centre Stone", [`${item.centreStoneOption.carat}ct`, item.centreStoneOption.colour, item.centreStoneOption.clarity].filter(Boolean).join(" ")],
    item?.engravingText && ["Engraving", item.engravingText],
  ].filter(Boolean);
}

// For order items (Order Confirmed, Order Detail, My Account Orders)
// Order data uses a different structure than cart data.
// Handles both direct fields and _doc/variation fallbacks for Mongoose subdocs.
export function getOrderVariantTags(item) {
  const d = item?._doc || item;
  const eb = d?.engagementBuild || null; // halo engagement build snapshot
  const mc = d?.metalDetails?.metalComponents?.[0];
  const rawPurity = (mc?.purity || "").toUpperCase().replace(/K$/, "");
  const purity = rawPurity ? `${rawPurity}K` : "";
  const metalName = mc?.metalType || "";
  const metalType = d?.variationName || d?.variation?.variationName || eb?.metalLabel || (purity && metalName ? `${purity} ${metalName}` : purity || metalName) || "";
  const colour = d?.color || d?.Color || d?.colour || d?.Colour || d?.variation?.colors?.[0]?.color || "";
  const rawSize = d?.size || d?.SizeName || d?.metalDetails?.sizeLabel || d?.metalDetails?.size || eb?.sizeLabel || "";
  const size = rawSize && rawSize !== "0" && rawSize !== 0 ? rawSize : "";
  const quality = d?.quality || d?.Quality || "";
  const sku = d?.sku || d?.SKU || "";

  const engraving = d?.engravingText || "";

  const cso = d?.centreStoneOption || {};
  const centreStone = cso.carat || 0;

  return [
    metalType && metalType !== "-" && ["Metal", metalType],
    colour && colour !== "-" && ["Colour", colour],
    size && size !== "-" && ["Size", size],
    quality && quality !== "-" && ["Quality", quality],
    centreStone > 0 && ["Centre Stone", [`${centreStone}ct`, cso.colour, cso.clarity].filter(Boolean).join(" ")],
    eb && eb.goldWeightG ? ["Gold", `${eb.goldWeightG}g`] : null,
    eb && eb.meleeCount ? ["Melee", `${eb.meleeCount} stones · ${eb.meleeCarat}ct`] : null,
    sku && sku !== "-" && ["SKU", sku],
    engraving && ["Engraving", engraving],
  ].filter(Boolean);
}
